import type { TranslateVars } from './types'

const TOKEN_RE = /\{([a-zA-Z0-9_]+)\}/g

export function interpolate(template: string, vars?: TranslateVars): string {
  if (!vars) return template
  return template.replace(TOKEN_RE, (full, key: string) => {
    if (!(key in vars)) return full
    return String(vars[key])
  })
}
